import { ATM_ACCESSIBILITY_CODES } from '../../shared/constants/enum';
import { BranchElement } from '../../types/models';
import { useTranslation } from 'react-i18next';
import wheelChairIcon from '../../shared/img/wheelchair_outline.svg';
import headphoneIcon from '../../shared/img/volume_max_outline.svg';

export const AccessibilityIcons = ({
    branchListElements,
}: {
    branchListElements: BranchElement[];
}) => {
    const { t } = useTranslation();
    const hasWheelChairAccess = branchListElements.some(
        (branch: BranchElement) =>
            branch.BranchCode === ATM_ACCESSIBILITY_CODES.WHEELCHAIR_ACCESSIBLE,
    );

    const hasHeadphoneJack = branchListElements.some(
        (branch: BranchElement) =>
            branch.BranchCode ===
            ATM_ACCESSIBILITY_CODES.HEADPHONE_JACK_AVAILABLE,
    );

    if (!hasWheelChairAccess && !hasHeadphoneJack) return null;

    return (
        <div>
            {hasWheelChairAccess && (
                <img
                    src={wheelChairIcon}
                    alt={t('wheelChairAccess')}
                    title={t('wheelChairAccess')}
                />
            )}
            {hasHeadphoneJack && (
                <img
                    src={headphoneIcon}
                    alt={t('headphoneJack')}
                    title={t('headphoneJack')}
                />
            )}
        </div>
    );
};
